import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link, useParams } from 'react-router-dom';
import Button from '../components/Button';

// Örnek veri
interface SellerListing {
  id: number;
  title: string;
  location: string;
  price: number;
  image: string;
}

interface Seller {
  name: string;
  location: string;
  joinDate: string;
  rating: number;
  reviewCount: number;
  followers: number;
  about: string;
  listings: SellerListing[];
}

const sellerData: { [key: string]: Seller } = {
  "1": {
    name: "Ahmet Yılmaz",
    location: "Kadıköy, İstanbul",
    joinDate: "15.01.2023",
    rating: 4.8,
    reviewCount: 128,
    followers: 1200,
    about: "5 yıldır teknoloji ürünleri satıyorum. Tüm ürünlerim garantili ve orijinaldir.",
    listings: [
      {
        id: 1,
        title: "MSI Gaming Laptop",
        location: "Kadıköy, İstanbul",
        price: 25000,
        image: "../assets/images/laptop.jpg"
      },
      {
        id: 2,
        title: "Asus ROG Gaming PC",
        location: "Kadıköy, İstanbul",
        price: 35000,
        image: "../assets/images/laptop.jpg"
      }
    ]
  },
  "2": {
    name: "Mehmet Demir",
    location: "Beşiktaş, İstanbul",
    joinDate: "10.03.2022",
    rating: 4.5,
    reviewCount: 94,
    followers: 800,
    about: "Teknoloji meraklısıyım ve kullanmadığım ürünleri satıyorum. Ürünlerim temiz ve sorunsuzdur.",
    listings: [
      {
        id: 3,
        title: "Apple MacBook Pro",
        location: "Beşiktaş, İstanbul",
        price: 42000,
        image: "../assets/images/laptop.jpg"
      }
    ]
  }
};

const SaticiProfil: React.FC = () => {
  const { logout, user } = useAuth();
  const { id } = useParams<{ id: string }>();
  const [seller, setSeller] = useState<any>(null);
  
  useEffect(() => {
    console.log("Satıcı profil ID:", id);
    
    // ID'ye göre satıcı bilgilerini al
    if (id && sellerData[id]) {
      setSeller(sellerData[id]);
    } else {
      // ID yoksa veya bulunamadıysa varsayılan olarak ilk satıcıyı göster
      setSeller(sellerData["1"]);
    }
  }, [id]);

  if (!seller) {
    return <div className="container py-5 text-center">Satıcı bilgileri yükleniyor...</div>;
  }

  return (
    <>
      {/* Header kısmı */}
      <header className="header sticky-top bg-white">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            {/* Logo */}
            <Link className="navbar-brand fw-bold text-primary" to="/">
              <i className="fas fa-laptop me-2"></i>SadeceBilgisayar.com
            </Link>

            {/* Arama Kutusu */}
            <div className="search-box mx-lg-2 flex-grow-1" style={{ maxWidth: "75%", marginLeft: "-10px" }}>
              <form className="d-flex">
                <div className="input-group">
                  <input
                    aria-label="Arama"
                    className="form-control"
                    placeholder="Dizüstü, masaüstü, parça ara..."
                    type="search"
                  />
                  <Button className="btn btn-primary" type="submit">
                    <i className="fas fa-search" />
                  </Button>
                </div>
              </form>
            </div>

            {/* Sağ Menü */}
            <div className="nav-right">
              <Link className="btn btn-outline-primary me-2" to="/ilan-ver">
                <i className="fas fa-plus-circle me-2" />
                İlan Ver
              </Link>
              <Link className="btn btn-primary" to="/">
                <i className="fas fa-user me-2" />
                Giriş Yap
              </Link>
            </div>
          </div>
        </nav>
      </header>

      <main className="container py-4">
        {/* Satıcı Profil Kartı */}
        <div className="card mb-4">
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-md-2 text-center">
                <img alt="Profil" className="rounded-circle mb-3" height="120" src="../assets/images/user.jpg" width="120"/>
              </div>
              <div className="col-md-7">
                <h2 className="mb-2">{seller.name}</h2>
                <p className="text-muted mb-2"><i className="fas fa-map-marker-alt me-2 text-primary"></i>{seller.location}</p>
                <p className="text-muted mb-2"><i className="fas fa-user me-2 text-primary"></i>Üye Olma: {seller.joinDate}</p>
                <div className="d-flex align-items-center mb-2">
                  <div className="me-3">
                    <i className="fas fa-star text-warning"></i>
                    <span className="ms-1">{seller.rating}</span>
                    <span className="text-muted ms-2">({seller.reviewCount} değerlendirme)</span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 text-end">
                {/* Takipçi Sayısı */}
                <div className="mb-3">
                  <h4 className="mb-0">{seller.followers}</h4>
                  <small className="text-muted">Takipçi</small>
                </div>
                {/* Takip Et Butonu */}
                <Button className="btn btn-primary">
                  <i className="fas fa-plus me-2"></i>Takip Et
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Hakkında Bölümü */}
        <div className="card mb-4">
          <div className="card-body">
            <h4 className="card-title mb-3">Hakkında</h4>
            <p className="card-text">
              {seller.about}
            </p>
          </div>
        </div>

        {/* Aktif İlanlar */}
        <h3 className="mb-4">Aktif İlanlar</h3>
        <div className="row">
          {seller.listings.map((listing: SellerListing) => (
            <div key={listing.id} className="col-md-4 mb-4">
              <div className="card h-100">
                <img alt={listing.title} className="card-img-top" src={listing.image}/>
                <div className="card-body">
                  <h5 className="card-title">{listing.title}</h5>
                  <p className="card-text text-muted">{listing.location}</p>
                  <p className="card-text fw-bold">{listing.price.toLocaleString('tr-TR')} ₺</p>
                  <Link className="btn btn-outline-primary" to={`/ilan-detay/${listing.id}`}>İlana Git</Link>
                </div>
              </div>
            </div>
          ))}
          {seller.listings.length === 0 && (
            <div className="col-12 text-center">
              <p className="text-muted">Bu satıcının aktif ilanı bulunmamaktadır.</p>
            </div>
          )}
        </div>

        {/* Değerlendirmeler */}
        <h3 className="mb-4">Değerlendirmeler</h3>
        <div className="card mb-4">
          <div className="card-body">
            {/* Değerlendirme Özeti */}
            <div className="row mb-4">
              <div className="col-md-6">
                <h4 className="mb-3">Genel Puan</h4>
                <div className="d-flex align-items-center">
                  <div className="display-4 me-3">{seller.rating}</div>
                  <div>
                    <div className="mb-1">
                      <i className="fas fa-star text-warning"></i>
                      <i className="fas fa-star text-warning"></i>
                      <i className="fas fa-star text-warning"></i>
                      <i className="fas fa-star text-warning"></i>
                      <i className="fas fa-star-half-alt text-warning"></i>
                    </div>
                    <small className="text-muted">{seller.reviewCount} değerlendirme</small>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                {/* Yıldız Dağılımı */}
                <div className="mb-2">
                  <span className="me-2">5 Yıldız</span>
                  <div className="progress" style={{height: '8px'}}>
                    <div className="progress-bar bg-warning" style={{width: '80%'}}></div>
                  </div>
                  <span className="ms-2">80%</span>
                </div>
                {/* ... diğer yıldızlar ... */}
              </div>
            </div>

            {/* Değerlendirme Listesi */}
            <div>
              {/* Değerlendirme 1 */}
              <div className="border-bottom pb-3 mb-3">
                <div className="d-flex justify-content-between mb-2">
                  <div>
                    <img alt="Kullanıcı" className="rounded-circle me-2" height="32" src="../assets/images/user2.jpg" width="32"/>
                    <span className="fw-bold">Mehmet Demir</span>
                  </div>
                  <div>
                    <i className="fas fa-star text-warning"></i>
                    <i className="fas fa-star text-warning"></i>
                    <i className="fas fa-star text-warning"></i>
                    <i className="fas fa-star text-warning"></i>
                    <i className="fas fa-star text-warning"></i>
                  </div>
                </div>
                <p className="mb-2">Harika bir satıcı, ürün tam olarak anlatıldığı gibiydi. Çok memnun kaldım.</p>
                <small className="text-muted">15.02.2024</small>
              </div>
              {/* Diğer değerlendirmeler */}
            </div>

            {/* Sayfalama */}
            <div className="pagination-container py-4 border-top border-bottom">
              <nav aria-label="Değerlendirme sayfaları">
                <ul className="pagination pagination-lg justify-content-center mb-0">
                  <li className="page-item disabled">
                    <Button className="page-link" disabled>
                      <i className="fas fa-chevron-left me-1"></i> Önceki
                    </Button>
                  </li>
                  <li className="page-item active">
                    <Button className="page-link">1</Button>
                  </li>
                  <li className="page-item">
                    <Button className="page-link">2</Button>
                  </li>
                  <li className="page-item">
                    <Button className="page-link">3</Button>
                  </li>
                  <li className="page-item">
                    <Button className="page-link">
                      Sonraki <i className="fas fa-chevron-right ms-1"></i>
                    </Button>
                  </li>
                </ul>
              </nav>
              <div className="text-center text-muted mt-3">
                <small>Toplam <strong>15</strong> değerlendirme içinden <strong>1-5</strong> arası gösteriliyor</small>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* CSS ekleyelim */}
      <style>
        {`
        /* Pagination Styles */
        .pagination-container {
          background-color: #f8f9fa;
          border-color: #e9ecef !important;
        }
        
        .pagination .page-link {
          color: #212529;
          background-color: #ffffff;
          border-color: #dee2e6;
          border-radius: 8px;
          margin: 0 4px;
          padding: 12px 20px;
          transition: all 0.3s ease;
          font-weight: 600;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }
        
        .pagination .page-link:hover {
          background-color: #f8f9fa;
          border-color: #dee2e6;
          transform: translateY(-3px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          color: #0d6efd;
        }
        
        .pagination .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
          color: white;
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3);
        }
        
        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          pointer-events: none;
          background-color: #ffffff;
          border-color: #dee2e6;
          opacity: 0.6;
        }
        
        .pagination-lg .page-link {
          font-size: 1rem;
        }
        
        @media (max-width: 576px) {
          .pagination .page-link {
            padding: 8px 12px;
            font-size: 0.9rem;
          }
        }
        `}
      </style>

      {/* Footer */}
      <footer className="footer mt-auto py-5 bg-white border-top">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-3 text-center">
              <h5 className="mb-3 text-dark">Hakkımızda</h5>
              <p className="text-secondary">
                SadeceBilgisayar.com, sıfır veya İkinci el teknolojik ürünleri güvenilir bir şekilde alım veya satım yapabileceğiniz bir platformdur.
              </p>
            </div>
            <div className="col-lg-3 text-center">
              <h5 className="mb-3 text-dark">Önemli Tavsiyeler</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link className="text-secondary text-decoration-none d-inline text-nowrap" to="/masaustu_tavsiyeler">
                    Masaüstü alırken dikkat edilmesi gerekenler
                  </Link>
                </li>
                <li className="mb-2">
                  <Link className="text-secondary text-decoration-none d-inline" to="/laptop-tavsiyeler">
                    Laptop alırken dikkat edilmesi gerekenler
                  </Link>
                </li>
                <li className="mb-2">
                  <Link className="text-secondary text-decoration-none d-inline" to="/donanim-tavsiyeler">
                    Donanım alırken dikkat edilmesi gerekenler
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 text-center">
              <h5 className="mb-3 text-dark">İletişim</h5>
              <div className="contact-info">
                <p className="text-secondary mb-2">Görüşleriniz ve şikayetleriniz için</p>
                <p className="text-secondary mb-2">
                  <i className="fas fa-envelope me-2"></i>
                  info@sadecebilgisayar.com
                </p>
              </div>
            </div>
            <div className="col-lg-3 text-center">
              <h5 className="mb-3 text-dark">Sosyal Medya Hesaplarımız</h5>
              <div className="social-links">
                <a className="text-primary me-4" href="#">
                  <i className="fab fa-facebook fa-3x"></i>
                </a>
                <a className="text-danger me-4" href="#">
                  <i className="fab fa-instagram fa-3x"></i>
                </a>
                <a className="text-danger" href="#">
                  <i className="fab fa-youtube fa-3x"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom mt-5 pt-4 border-top">
            <div className="row">
              <div className="col-md-6">
                <p className="text-secondary mb-0">© 2024 SadeceBilgisayar.com - Tüm hakları saklıdır.</p>
              </div>
              <div className="col-md-6 text-md-end">
                <Link className="text-secondary me-3" to="/gizlilik-sozlesmesi">Gizlilik Politikası</Link>
                <Link className="text-secondary me-3" to="/kullanici-sozlesmesi">Kullanım Koşulları</Link>
                <Link className="text-secondary" to="/cerez-politikasi">Çerez Politikası</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default SaticiProfil;
